module.exports = __webpack_public_path__ + "static/media/Group2681.13ff9fa8.png";